import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux'
import { Card, CardTitle, CardText } from 'react-mdl'
import * as actions from '../actions/index'
import * as styles from '../styles/styles'

import config from '../utils/config'

var introJs = require("intro.js").introJs();
var willShowIntro = false

class ChannelTypeSelector extends Component{

  static propTypes = {
    location: PropTypes.object.isRequired,
    channelTypes: PropTypes.array.isRequired
  }

  static contextTypes = {
    router: PropTypes.object.isRequired
  }

  constructor(props,context) {
    super(props,context);

    this.addChannel = this.addChannel.bind(this);

    this.filterChannelTypes()
  }

  componentWillMount() {
    this.props.dispatch(actions.setTopbarButtons([]))
    if (this.state.filteredChannelTypes.length === 0) {
      this.goBack()
    }

    if (!sessionStorage.getItem('introjs_ChannelTypeSelector_usms')) {
      willShowIntro = true
      sessionStorage.setItem('introjs_ChannelTypeSelector_usms', true)
    }
  }

  componentDidMount() {
    if (willShowIntro && !this.props.children) {
      introJs.setOptions({ 'showStepNumbers': false, 'showBullets': false });
      introJs.start()

      willShowIntro = false
    }
  }

  addChannel(cfg) {
    introJs.exit()

    if (cfg['readonly']) {
      return
    }

    const channelType = cfg["id"]
    const pathComponents = this.props.location.pathname.split("/");
    pathComponents.pop()
    pathComponents.pop()
    const path = pathComponents.join("/")
    this.context.router.push(`${path}/channels/${channelType}`);
  }

  goBack() {
    const pathComponents = this.props.location.pathname.split("/");
    pathComponents.pop()
    const path = pathComponents.join("/")
    this.context.router.push(path);
  }

  render() {
    const {filteredChannelTypes} = this.state

    if (filteredChannelTypes === null) {
      return ( <div></div> )
    }

    return (
      <div>
        {filteredChannelTypes.map((cfg) => (
            <div onClick={()=>{this.addChannel(cfg)}}
                key={cfg["id"]}
                style={!cfg['readonly'] ? styles.channelTypeSelector.cardDiv : styles.channelTypeSelector.cardDiv_noclick}
                {...cfg["id"]==='usms' ? {'data-intro':'Let’s allow your customers to reach you by SMS. Click the SMS card to continue.'} : {}}>
              <Card shadow={0} style={styles.channelTypeSelector.card}>
                <CardTitle expand style={styles.channelTypeSelector.cardTitle}>
                  <h4 style={{marginTop: '0', fontSize: '22px'}}>{cfg["name"]}</h4>
                </CardTitle>
                <CardText style={styles.channelTypeSelector.cardText}>
                  {cfg["info"]}
                </CardText>
              </Card>
            </div>
        ),this)}
      </div>
    )
  }

  // CHANNEL TYPES FILTERING

  filterChannelTypes() {
    const { channelTypes, location } = this.props

    const pathComponents = location.pathname.split("/");
    const role = pathComponents[pathComponents.length - 1]

    let filteredChannelTypes = channelTypes.filter( (value) => {
      return value.id.startsWith(role);
    });

    // We show only certain channels in production environment,
    // the channels and their order is defined in utils/config.js
    if (config.ENABLED_CHANNELS) {
      // ChannelInfo by ID
      let hash = {}
      for (let i = 0, len = filteredChannelTypes.length; i < len; i++) {
        const ch = filteredChannelTypes[i];
        hash[ch.id] = ch;
      }

      filteredChannelTypes = []
      for (let i = 0, len = config.ENABLED_CHANNELS.length; i < len; i++) {
        const t = config.ENABLED_CHANNELS[i];
        const ch = hash[t];
        if (t.startsWith(role) && ch) {
          filteredChannelTypes.push(ch);
        }
      }
    }

    this.state = { filteredChannelTypes }
  }

}

export default connect()(ChannelTypeSelector)



// WEBPACK FOOTER //
// ./src/containers/ChannelTypeSelector.js